/* Native popovers keep evidence above glass surfaces, with tap/keyboard fallback. */
if (!customElements.get('ss-comparison-note')) {
  customElements.define('ss-comparison-note', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.note = this.querySelector('[popover]');
      if (!this.button || !this.note || !this.note.showPopover) return;
      this.events = new AbortController();
      const on = (target, event, handler) => target.addEventListener(event, handler, { signal: this.events.signal });
      const cancel = () => clearTimeout(this.timer);
      const close = () => { cancel(); if (this.note.matches(':popover-open')) this.note.hidePopover(); };
      const leave = event => {
        if (event.pointerType === 'mouse') this.timer = setTimeout(close, 180);
      };
      on(this.button, 'pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        cancel();
        this.note.showPopover();
        this.position();
      });
      on(this.button, 'pointerleave', leave);
      on(this.note, 'pointerenter', cancel);
      on(this.note, 'pointerleave', leave);
      on(this.button, 'blur', close);
      on(this.note, 'toggle', event => {
        const open = event.newState === 'open';
        this.button.setAttribute('aria-expanded', String(open));
        if (open) this.position();
      });
      const reposition = () => {
        if (!this.note.matches(':popover-open')) return;
        const anchor = this.button.getBoundingClientRect();
        if (anchor.bottom < 0 || anchor.top > innerHeight) close();
        else this.position();
      };
      on(window, 'resize', reposition);
      on(document, 'scroll', reposition);
    }
    position() {
      const anchor = this.button.getBoundingClientRect();
      const box = this.note.getBoundingClientRect();
      const gap = 8;
      const left = Math.max(12, Math.min(anchor.left, innerWidth - box.width - 12));
      let top = anchor.bottom + gap;
      if (top + box.height > innerHeight - 12) top = anchor.top - box.height - gap;
      this.note.style.left = `${left}px`;
      this.note.style.top = `${Math.max(12, top)}px`;
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.events?.abort();
    }
  });
}
